<template>
  <div class="home">
    <div class="header">
      <img src="./img/logo_512.png" alt="" srcset="" style="height:100%">
      <div class="right">多卡拉-物流人的信息平台</div>
    </div>
    <img src="./img/bg.png"  style="width:100%" alt="" srcset="">
    <h2 class="way">为什么要加入多卡拉</h2>
    <div class="desc-box">
      <div class="desc">
        <img src="./img/01.12c5e3cf.png" alt="省钱">
        <h3>省钱</h3>
        <p>
          货车多 运力足<br>
          先比价 再发货
        </p>
      </div>
      <div class="desc">
        <img src="./img/04.f559974c.png" alt="省事">
        <h3>省事</h3>
        <p>
          一键发布用车需求<br>
          平台精准车货匹配
        </p>
      </div>
      <div class="desc">
        <img src="./img/03.92846ab1.png" alt="省时">
        <h3>省时</h3>
        <p>
          500万司机在线接单<br>
          3秒快速响应 随叫随到
        </p>
      </div>
      <div class="desc">
        <img src="./img/02.ee39d2b7.png" alt="省心">
        <h3>省心</h3>
        <p>
          担保交易 货损必赔<br>
          实时查看货物动态
        </p>
      </div>
    </div>
    <div class="footer">汉中全新企点信息科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;陕ICP备19012016号</div>
    <div class="code">
      <img src="./img/android.png" alt="" srcset="">
      <img src="./img/ios.png" alt="" srcset="">
      <span>Android下载</span>
      <span>IOS下载</span>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
    }
  }
}
</script>

<style lang='less'>
    .home{
      .header{
        display: flex;
        height: 78px;
        .right{
          line-height: 78px;
          width:calc(100% - 78px);
          font-size: 24px;
          font-weight: 700;
          color: #ffffff;
          background-color: #3a495f;
          text-indent: 20px;
        }
      }
      .way{
            padding: 100px 0;
            font-size: 34px;
            line-height: 48px;
            font-weight: 700;
            text-align: center;
            color: #f5bd02;
      }
      .desc-box{
        display: flex;
        justify-content: space-around;
        .desc{
          text-align: center;
          margin-bottom: 110px;
          h3{
            margin-top: 53px;
            font-size: 25px;
            color: #333;
            line-height: 33px;
          }
        }
      }
      .footer{
        line-height: 66px;
        text-align: center;
        font-size: 18px;
        color: #fff;
        background-color: #3a495f;
      }
      .code{
        width: 450px;
        height: 200px;
        // background: red;
        position: absolute;
        right: 10vw;
        top: 30vh;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        >img{
          width: 200px;
        }
        >span{
          color: #ffffff;
          margin-top: 10px;
          font-size: 400;
        }
      }
    }
</style>
